module.exports = __webpack_public_path__ + "static/media/dirs.7a281e37.jpg";